import React from "react";
import "./SportIcon.style.scss";

const SportIcon = ({sportId})=> {
    return <div className={`SportIcon _${sportId}`}/>
}
export default SportIcon;